export default __webpack_public_path__ + "static/media/drakkar-footer.4622c25e.png";